module.exports = __webpack_public_path__ + "static/media/company8.514c32df.png";